import { render, staticRenderFns } from "./selectbaseProduct.vue?vue&type=template&id=a552e27c&scoped=true&"
import script from "./selectbaseProduct.vue?vue&type=script&lang=js&"
export * from "./selectbaseProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a552e27c",
  null
  
)

export default component.exports